import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Panel } from '@core/models/panel';

@Injectable()
export class PanelsService {

  private _panels: Panel = {
    isOpenRight: true,
    isOpenLeft: false,
    leftSize: '500px'
  };

  panels$ = new BehaviorSubject<Panel>(this._panels);
  shipmentPanels$ = new BehaviorSubject<Panel>(this._panels);
  
  constructor() { }

  openOrderPanel(): void {
    this.panels$.next({
      ...this._panels,
      isOpenLeft: true,
    })
  }

  closeOrderPanel(): void {
    this.panels$.next({
      ...this._panels,
      isOpenLeft: false,
    })
  }

  openShipmentPanel(): void {
    this.shipmentPanels$.next({
      ...this._panels,
      isOpenLeft: true,
    })
  }

  closeShipmentPanel(): void {
    this.shipmentPanels$.next({
      ...this._panels,
      isOpenLeft: false,
    })
  }
}
